<!--
 * @Author: 曹捷
 * @Date: 2019-08-13 10:49:35
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-04-28 11:56:06
 * @Description: 机构管理
 -->
<template>
  <obitUniversalTable name="机构列表" v-if="$fmt(['sys_normal_disable'])" class="deptIndex">
    <template #search>
      <obit-search-form :params="params" :paramList="paramList" @search="pageQuerylist(true)">
      </obit-search-form>
    </template>
    <template #btn>
      <a-button type="primary" @click="addDialog('0')">
        <i class="iconfont icon-add-bold p-r-5"></i> 新 增
      </a-button>
    </template>
    <a-table class="obit-atable" :columns="tableColumns" :data-source="deptList" rowKey="deptId" :expandRowByClick="true">
      <template #roles="{ record  }" :key="record.deptId">
        <span class="m-r-5" animation="line-left-bottom reverse" v-for="item in record.roles" :key="item.roleId">
          {{item.roleName}}
        </span>
      </template>
      <template #status="{record}" :key="record.deptId">
        <div @click.stop>
          <obitSwitchUrl v-model:value="record.status" check="正常" uncheck="停用" activeValue="0" inactiveValue="1"
            :info="{ ajaxUrl:'system/dept/editState', fieldName: 'status',ajaxType: 'post',data:{deptId:record.deptId} }" @reload="pageQuerylist(true)">
          </obitSwitchUrl>
        </div>
      </template>
      <template #operation="{ record  }" :key="record.deptId">
        <a-button type="link" class="operation-btn" @click.stop="details(record)"> 查看</a-button>
        <a-button type="link" class="operation-btn" @click.stop="editDialog(record)">编辑</a-button>
        <a-button type="link" class="operation-btn" @click.stop="remove(record)"> 删除</a-button>
        <a-button type="link" class="operation-btn" @click.stop="addDialog(record.deptId)">新增子项</a-button>
      </template>
    </a-table>
  </obitUniversalTable>
  <orgAdd :addType="pageType" v-model:open="pageVisable" v-if="pageVisable" :detailsInfo="detailsInfo" @reload="pageQuerylist(true)">
  </orgAdd>
  <orgDetails v-model:open="pageDetailsVisable" v-if="pageDetailsVisable" :dataInfo="dataInfo" :parentDeptList="parentDeptList" @reload="pageQuerylist(true)">
  </orgDetails>
</template>

<script>
import { getCurrentInstance, inject, onMounted, reactive, toRefs } from 'vue'
import orgAdd from './orgAdd.vue'
import orgDetails from './orgDetails.vue'
import obitSwitchUrl from '../../../components/obitSwitchUrl.vue'
export default {
  components: { orgAdd,orgDetails,obitSwitchUrl },

  setup (props, contenxt) {
    let { proxy } = getCurrentInstance()
    let http = inject('http')
    let _data = reactive({
      params: {},
      pageType: 'add',
      pageVisable: false,
      detailsInfo: {},
      formData: {},
      deptList: [],
      parentDeptList: [],
      pageDetailsVisable: false,
      dataInfo: {},
      tableColumns: [
        { dataIndex: 'sort', title: '编号' ,width: '80px'},
        { dataIndex: 'deptName', title: '机构名称', width: '200px'},
        { dataIndex: 'createTime', title: '创建时间', width: '180px' },
        { slots: { customRender: 'status' }, title: '状态', width: 100 },
        { title: '操作', slots: { customRender: 'operation' }, width: '180px' },
      ],
      paramList: [
        { name: '机构名称', key: 'deptName' },
        { name: "机构状态", key: "status", type: "dict", dictCode: "sys_normal_disable" },
      ],
    })
    let _methods = {
      // 数据加载
      pageQuerylist () {
        let params = {
          deptName: _data.params.deptName,
          status: _data.params.status,
        }
        http.sysPost("system/dept/list", params).then((res) => {
          _data.parentDeptList = res
          let datas = res
          let result = []
          if (!Array.isArray(datas)) {
            return result
          }
          datas.forEach((item,index) => {
            delete item.children;
            item.sort = index+1
          });
          let map = {};
          datas.forEach(item => {
            map[item.deptId] = item;
          });
          datas.forEach(item => {
            let parent = map[item.parentId];
            if (parent) {
              (parent.children || (parent.children = [])).push(item);
            } else {
              result.push(item);
            }
          });
          _data.deptList = result;
        })
      },
      // 新增组件
      addDialog (item) {
        _data.detailsInfo = {
          parentId: item
        }
        _data.pageType = 'add'
        _data.pageVisable = true
      },
      // 编辑组件
      editDialog (item) {
        _data.detailsInfo = item
        _data.pageType = 'edit'
        _data.pageVisable = true
      },
      //详情
      details(item){
        _data.dataInfo = item
        _data.pageDetailsVisable = true
      },
      // 删除
      remove (item) {
        proxy.$confirm({
          title: '提示',
          content: '是否删除',
          onOk () {
             let fors = {
              id: item.deptId
            }
            http.sysPost("system/dept/remove", fors).then((res) => {
              proxy.$message.success('删除成功')
              _methods.pageQuerylist()
            })
          },
        })
      },
    }
    onMounted(() => {
      _methods.pageQuerylist()
    })
    return {
      ...toRefs(_data),
      ..._methods,
    }
  },
}
</script>

<style lang="less">

</style>